import { render, staticRenderFns } from "./add-zone.vue?vue&type=template&id=8416ed78&scoped=true"
import script from "./add-zone.vue?vue&type=script&lang=js"
export * from "./add-zone.vue?vue&type=script&lang=js"
import style0 from "./add-zone.vue?vue&type=style&index=0&id=8416ed78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8416ed78",
  null
  
)

export default component.exports